<template>
  <div class="w1200">
    <div class="bg1" style="min-height: calc(100vh - 240px)">
      <h3 style="line-height: 50px; padding: 0 30px">版本说明</h3>
      <dl
        v-for="(e, i) in configure.edition"
        :key="'edition' + i"
        style="margin-bottom: 20px"
      >
        <dt style="text-indent: 2em">{{ e.id }}</dt>
        <dd v-for="(l, j) in e.list" :key="j" style="text-indent: 3em">
          {{ l }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeNames: 1,
    };
  },
  computed: {
    ...mapState(["configure"]),
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/edition.vue